import $ from 'jquery';
import 'what-input';
import GLightbox from 'glightbox';

window.$ = window.jQuery = $;

import './lib/foundation-explicit-pieces';
import tippy from 'tippy.js';

require('./lib/jquery.fitVids.js');
require('./lib/jquery.matchHeight.js');
// require('./lib/jquery.slick.js');

$(document).ready(function() {

	$(document).foundation();

	$('body').fitVids({
		customSelector: 'iframe[src*="facebook"], iframe[src^="https://livestream.com"]'
	});

	$('nav.main-nav .menu-item-has-children>a, .off-canvas-navigation .menu-item-has-children>a').attr('aria-expanded', "false");

	$('nav.main-nav .menu-item-has-children>a, .off-canvas-navigation .menu-item-has-children>a').click(function(event) {
		event.stopPropagation();
		event.preventDefault();
		if ($(this).parent().hasClass('nav-open')) {
			$('.nav-open .sub-menu').slideUp('fast',
				function() {
				$('.nav-open>a').attr('aria-expanded', "false");
			    $('.nav-open').removeClass('nav-open');
			});
		} else {
			$('.nav-open .sub-menu').hide();
			$('.nav-open').removeClass('nav-open');
			$(this).parent().addClass('nav-open');
			$(this).parent().find('.sub-menu').slideDown('fast');
			$(this).attr('aria-expanded', "true");
		}
	});

	const lightbox = GLightbox({
	    touchNavigation: true
	});

	$('#citSearchForm #citSearchValue').attr('placeholder', 'Search the collection');
	$('#citSearchForm').append('<input type="submit" value="Go" class="button cit_search_submit" id="citSearchSubmit" />');


	$( '.cit_folders_wrapper .cit_folder_list_row' ).each(function( index ) {
		var cit_url = $(this).find('.w-sm-4 a').attr('href');
		$(this).find('.cit_folder_content').append('<a href="'+cit_url+'" class="text-button">Explore This Collection</a>');$
	});

	$('#event-filter').submit( function(){
    	event.stopPropagation();
		event.preventDefault();
        window.location.href = $(this).find('select').val();
    });

    $('.read-more').click(function(event) {
    	if ( !$(this).hasClass('read-more-open')) {
			$(this).addClass('read-more-open');
		}
	});

	$('.nav-search-toggle a').click(function(event) {
    	$(this).siblings('.search-container').slideToggle('fast');
	});

	$('img').each(function( index ) {
    	if( $( this ).data('media-credits') ) {
    		var credits = $( this ).data('media-credits');
    		credits = String(credits).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    		$(this).wrap('<span class="media-with-credits"></span>');
    		$(this).after('<button class="credits-tooltip" data-tippy-content="'+credits+'">i</button>');
    		if( $( this ).hasClass('aligncenter') ) {
    			$(this).parent('.media-with-credits').wrap('<div class="media-with-credits-center"></div>');
    		}
    	} else if( $( this ).data('featured-media-credits') ) {
    		var credits = $( this ).data('featured-media-credits');
    		credits = String(credits).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    		$(this).after('<button class="credits-tooltip" data-tippy-content="'+credits+'">i</button>');
    	}
    	$('.media-with-credits img.alignleft').each(function( index ) {
    		$(this).parent('.media-with-credits').addClass('alignleft');
    	});
    	$('.media-with-credits img.alignright').each(function( index ) {
    		$(this).parent('.media-with-credits').addClass('alignright');
    	});
    	$('.media-with-credits img.alignnone').each(function( index ) {
    		$(this).parent('.media-with-credits').addClass('alignnone');
    	});
    });

    tippy('[data-tippy-content]', {
	  interactive: true,
	  maxWidth: 250,
	  touch: 'hold'
	});

	$('select#news-topic').change(function(event) {
		var url = $(this).val();
		window.location.href = url;
	});

});